export default {
  paymentSettings: []
}
